<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        SKU Variant List
      </div>
      <v-spacer></v-spacer>
      <v-btn
        small
        color="primary"
        class="mr-4"
        v-if="checkPermission('app_sku_variant:b2b_sku_barcode_upload')"
        @click="$router.push('upload-barcode')"
        >Upload Barcode</v-btn
      >
      <v-btn
        small
        color="primary"
        class="mr-8"
        v-if="checkPermission('app_sku_variant:b2b_sku_variant_create')"
        @click="$router.push('add-edit-sku/0')"
        >Add SKU Variant</v-btn
      >
    </div>
    <v-divider class="mt-4 mb-4 mr-8"></v-divider>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" max-width="400" max-height="500">
          <v-card>
            <v-card-title class="card-title">
              Mapped Images- {{ selectedItem.variant_sku_code }}-({{
                selectedItem.sku_code
              }})

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-if="selectedItem.variant_sku_description.length > 50"
                    v-on="on"
                    style="font-size: 12px"
                    >{{
                      selectedItem.variant_sku_description.slice(0, 50) + "..."
                    }}</span
                  >
                </template>
                <span style="font-size: 12px">{{
                  selectedItem.variant_sku_description
                }}</span>
              </v-tooltip>
            </v-card-title>
            <v-divider class="mb-4"></v-divider>
            <v-card-text>
              <v-carousel
                cycle
                hide-delimiters
                interval="5000"
                show-arrows-on-hover
                height="200"
                v-if="images && images.length > 1"
              >
                <v-carousel-item
                  v-for="(image, index) in images"
                  :key="index"
                  :src="image"
                  :alt="image.alt"
                  max-height="200"
                  class="carousel-image"
                  contain
                ></v-carousel-item>
              </v-carousel>
              <v-img v-else :src="images[0]"></v-img>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-data-table
      :headers="headersChild"
      :items="resultChild"
      :options.sync="options"
      class="elevation-1 custom-icon-size mr-8"
      :server-items-length="total"
      :loading="loader"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.variant_sku_code`]="{ item }">
        <v-icon v-if="item.sku_type == 1" color="success">mdi-barcode</v-icon>
        <v-icon v-if="item.sku_type == 0" color="primary"
          >mdi-book-variant</v-icon
        >{{ item.variant_sku_code }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at"
          >{{
            item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}
          <span v-if="item.created_by">({{ item.created_by }})</span></span
        >
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at"
          >{{
            item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
          }}
          <span v-if="item.updated_by">({{ item.updated_by }})</span></span
        >
      </template>
      <template v-slot:[`item.variant_sku_description`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-if="item.variant_sku_description.length > 80" v-on="on">{{
              item.variant_sku_description.slice(0, 80) + "..."
            }}</span>
            <span v-else>{{ item.variant_sku_description }}</span>
          </template>
          <span>{{ item.variant_sku_description }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.client_name`]="{ item }">
        {{ item.client_name }} ({{ item.storer_name }})
      </template>
      <template v-slot:[`item.dimension`]="{ item }">
        {{
          (item.width ? item.width : "-") +
          " x " +
          (item.height ? item.height : "-") +
          " x " +
          (item.length ? item.length : "-")
        }}
      </template>
      <template v-slot:[`item.size`]="{ item }">
        {{
          (item.size ? item.size : "-") +
          " / " +
          (item.design ? item.design : "-") +
          " / " +
          (item.aroma ? item.aroma : "-")
        }}
      </template>
      <template v-slot:[`item.volume`]="{ item }">
        {{
          (item.volume ? item.volume : "-") +
          " / " +
          (item.variant ? item.variant : "-")
        }}
      </template>

      <template v-slot:[`item.variant`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-if="item.variant && item.variant.length > 80" v-on="on">{{
              item.variant.slice(0, 80) + "..."
            }}</span>
            <span v-else-if="item.variant">{{ item.variant }}</span>
          </template>
          <span v-if="item.variant">{{ item.variant }}</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <v-form ref="form" type="submit">
          <div class="custom-row">
            <v-col
              cols="12"
              sm="3"
              class="pb-0"
              v-if="
                userCategory.user_category === 3 ||
                userCategory.user_category === 6
              "
            >
              <v-autocomplete
                v-model="client"
                :items="clients"
                item-text="name"
                item-value="id"
                label="Select Client"
                class="pb-0"
                @focus="fetchClientList"
                outlined
                @change="getwarehouse(client)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0">
              <v-autocomplete
                v-model="warehouse"
                label="Warehouse"
                item-text="name"
                item-value="id"
                :items="warehouses"
                outlined
                @change="getStores(client, warehouse_id)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="pb-0" v-if="client">
              <v-autocomplete
                v-model="infor_storer_id"
                label="Storer Name"
                item-text="channel_name"
                item-value="id"
                :items="stores"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                outlined
                v-model="sku"
                label="Variant SKU"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                outlined
                v-model="b2b_sku_code"
                label="SKU Code"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(from_date)"
                    label="From Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.from_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="from_date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="dateMenuTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(to_date)"
                    label="To Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    outlined
                    @click:clear="clearDateInput('this.to_date')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="to_date"
                  @input="dateMenuTo = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                item-text="text"
                item-value="value"
                label="Sku Mapping Status"
                class="pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="sftp_status"
                :items="sftpstatuses"
                item-text="text"
                item-value="value"
                label="SFTP Status"
                class="pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="image_mapped"
                :items="mapped"
                item-text="text"
                item-value="value"
                label="Image Mapped"
                class="pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="sku_type"
                :items="types"
                item-text="text"
                item-value="value"
                label="Sku Type"
                class="pb-0"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              :sm="
                userCategory.user_category === 1 && client
                  ? '6'
                  : (userCategory.user_category === 3 ||
                      userCategory.user_category === 6) &&
                    client
                  ? '12'
                  : '6'
              "
            >
              <v-btn color="white" @click="clearAll" style="float: right"
                >Clear</v-btn
              >
              <v-btn
                color="primary"
                class="success mr-5"
                @click="searchAll"
                style="float: right"
                >Search</v-btn
              >
              <v-btn
                color="primary"
                @click="listpage()"
                class="success mr-5"
                style="float: right"
                v-if="checkPermission('app_ecom_vendors:excel_details')"
                >uploaded Barcode list</v-btn
              >
            </v-col>
          </div>
        </v-form>
        <v-divider class="mb-4"></v-divider>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          class="ma-1"
          :color="item.status == 1 ? 'green' : 'red'"
          text-color="white"
        >
          {{ item.status == 1 ? "Active" : "Inactive" }}
        </v-chip>
      </template>
      <template v-slot:item.variant_sku_mapping_status="{ item }">
        <v-chip
          class="ma-1"
          :color="item.variant_sku_mapping_status == 2 ? 'green' : 'red'"
          text-color="white"
        >
          {{
            item.variant_sku_mapping_status == 2 ? "Completed" : "In Progress"
          }}
        </v-chip>
      </template>
      <template v-slot:item.sftp_status="{ item }">
        <v-chip
          class="ma-1"
          :color="item.sftp_status == 1 ? 'green' : 'red'"
          text-color="white"
        >
          {{ item.sftp_status == 1 ? "Completed" : "Pending" }}
        </v-chip>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          icon
          @click="sync(item)"
          v-if="
            item.variant_sku_mapping_status !== 2 &&
            checkvisible(item.created_at) &&
            checkPermission('app_sku_variant:btb_sku_variant_sync')
          "
        >
          <v-icon>mdi-sync</v-icon>
        </v-btn>
        <v-btn icon @click="imagesFunction(item)" v-if="checkIcon(item)">
          <v-icon>mdi-image</v-icon>
        </v-btn>
        <v-btn icon @click="editFunction(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      sftp_status: "",
      loader: false,
      images: [],
      status: "",
      dialog: false,
      from_date: null,
      to_date: null,
      dateMenuTo: false,
      dateMenu: false,
      total: 0,
      search: "",
      clients: [],
      options: {},
      client: null,
      result: [],
      sku: "",
      b2b_sku_code: "",
      resultChild: [],
      types: [
        { text: "Generate a Variant", value: 0 },
        { text: "Add an existing Barcode", value: 1 },
      ],

      statuses: [
        { text: "Not Updated", value: 0 },
        { text: "Sync Successfully", value: 2 },
        { text: "Sync Failed", value: 3 },
      ],
      sftpstatuses: [
        { text: "Completed", value: 1 },
        { text: "Pending", value: 0 },
      ],
      mapped: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      headersChild: [
        {
          text: "Client (Storer)",
          value: "client_name",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Warehouse",
          value: "warehouse_name",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "SKU Code",
          value: "sku_code",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "SKU Variant/Barcode Code",
          value: "variant_sku_code",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "SKU Variant/Barcode Description",
          value: "variant_sku_description",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Size / Design / Aroma",
          value: "size",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Volume / Variant",
          value: "volume",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Color",
          value: "color",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "W x H x L (In cm)",
          value: "dimension",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: "200px",
        },

        {
          text: "Weight (In gm)",
          value: "weight",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Status",
          value: "status",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Created (By)",
          value: "created_at",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: 120,
        },

        {
          text: "Updated (By)",
          value: "updated_at",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: 120,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
      ],
      searchButton: false,
      warehouses: [],
      warehouse: "",
      image_mapped: "",
      stores: [],
      image_mapping: [],
      selectedItem: {},
      sku_type: null,
    };
  },
  created() {
    if (
      this.userCategory.user_category == 3 ||
      this.userCategory.user_category == 6
    ) {
      this.fetchClientList();
    }
    if (this.$store.getters.user.user_category == 1) {
      this.client = this.$store.getters.user.id;
      this.getwarehouse(this.$store.getters.user.id);
    }
  },
  computed: {
    ...mapGetters(["userCategory"]),
  },
  watch: {
    options: {
      handler() {
        if (this.options.itemsPerPage > 24 || this.options.page > 1) {
          this.searchButton = false;
        }
        if (!this.searchButton) this.getlist();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getSkuListBB",
      "fetchClient",
      "syncSkuVariant",
      "getSkuImages",
      "getInforWarehouseListBB",
      "getChannelDropdownBB",
    ]),
    getwarehouse(id) {
      if (id) {
        this.warehouse = "";
        this.infor_storer_id = null;
        this.getInforWarehouseListBB(id).then((response) => {
          this.warehouses = response.data.result;
        });
      } else {
        this.warehouses = [];
      }
    },
    getStores(id) {
      if (id) {
        this.getChannelDropdownBB(id).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },
    imagesFunction(item) {
      this.selectedItem = item;
      let payload = {
        sku_variant_id: item.id,
        client_id: item.client_id,
      };
      this.getSkuImages(payload).then((res) => {
        if (res.data) {
          this.images = res.data.result;
          this.dialog = true;
        }
      });
    },
    checkvisible(date) {
      if (!date) return false;
      const [year, month, day, hours, minutes, seconds] = date
        .split(/[-\s:]+/)
        .map((x) => parseInt(x));
      const createAt = new Date(year, month - 1, day, hours, minutes, seconds);
      if (isNaN(createAt.getTime())) {
        return false;
      }
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - createAt.getTime();
      const oneMinute = 60 * 1000;
      return timeDifference > oneMinute;
    },

    checkIcon(item) {
      return this.image_mapping.includes(item.id);
    },
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      let obj = {
        sku_variant_code: this.sku ? this.sku.trim() : this.sku,
        client_id: this.client,
        from_date: this.from_date,
        warehouse_id: this.warehouse,
        storer_id: this.infor_storer_id,
        variant_sku_mapping_status: this.status,
        to_date: this.to_date,
        image_mapped: this.image_mapped,
        b2b_sku_code: this.b2b_sku_code,
        sftp_status: this.sftp_status,
        sku_type: this.sku_type,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    editFunction(item) {
      this.$router.push(`add-edit-sku/${item.id}`);
    },
    searchAll() {
      this.options.page = 1;
      this.searchButton = true;
      this.allFilters();
      this.getSkuListBB({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.result = res.data.records1;
          this.resultChild = res.data.records;
          this.image_mapping = res.data.image_mapping;

          this.total = res.data.total;
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    async clearAll() {
      this.sku_type = "";
      this.filtersArr = {};
      this.sku = null;
      this.client = "";
      this.to_date = null;
      this.from_date = null;
      this.warehouse = "";
      this.infor_storer_id = null;
      this.status = null;
      this.image_mapped = "";
      this.b2b_sku_code = "";
      this.sftp_status = "";
      this.warehouses = [];
      this.stores = [];
      this.searchButton = false;
      await this.getlist();
    },
    listpage() {
      this.$router.push({
        name: "barcodeStatusList",
        params: {
          type: "sku_barcode_upload",
        },
      });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0 && this.userCategory.user_category !== 1) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          variant: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },

    reset() {
      this.dialog = false;
      this.$refs.form.reset();
      this.file = null;
    },
    sync(item) {
      this.syncSkuVariant(item.id).then((res) => {
        this.snackBar({
          message: res.data.message,
        });
        this.getlist();
      });
    },
    getlist() {
      this.result = [];
      this.resultChild = [];
      this.searchButton = false;
      this.loader = true;
      this.getSkuListBB({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.result = res.data.records1;
          this.resultChild = res.data.records;
          this.image_mapping = res.data.image_mapping;
          this.total = res.data.total;
          this.loader = false;
        })

        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>

<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 5px 5px 5px !important;
}
.carousel-image {
  height: 100%;
  max-height: 200px;
  object-fit: contain;
}
.card-title {
  padding-left: 22px;
}
</style>
